var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlasLogo3HorizontalWhiteBig(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 250",
    style: {
      enableBackground: "new 0 0 500 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#76AADB"
    },
    d: "M144.26,19.57c0,71.85,0,143.69,0,215.54c4.81-0.01,33.97-0.56,54.18-23.11 c3.19-3.56,15.89-18.13,17.53-39.44c0.29-3.78,0.17-6.95,0-9.16c24.04-0.13,48.07-0.27,72.11-0.4c5.04,0.1,29.22,0.06,49.4-18.73 c22.45-20.89,22.39-48.61,22.31-52.99c-0.13-23.9-0.27-47.81-0.4-71.71c0.2-3.99,1.15-33.33-22.31-54.58 c-20.11-18.22-44.09-17.73-49-17.53c-24.04-0.13-48.07-0.27-72.11-0.4c-4.52,0-32.59,0.47-53.39,23.51 C144.49-9.39,144.19,14.13,144.26,19.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#FFFFFF"
    },
    d: "M215.58,18.77c0,24.17,0,48.34,0,72.51c14.87,0,29.75,0,44.62,0 c3.17,0,13.89-0.41,22.31-8.37c1.72-1.62,5.35-5.13,7.17-10.76c1.44-4.44,0.3-5.73,0.4-16.33c0.1-9.94,1.12-11.01,0-15.54 c-0.23-0.94-1.67-6.5-6.01-11.52c-8.79-10.18-22.46-10.05-24.67-9.99C244.79,18.77,230.19,18.77,215.58,18.77z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EDF9"
    },
    d: "M176.96,169.79h68.34c0,21.83-16.24,39.52-36.27,39.52h-71.59c0-0.13,0.01-0.26,0.01-0.38 c0,0-0.01,0-0.01,0V76.99c0-20.03,17.69-36.27,39.52-36.27V169.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EDF9"
    },
    d: "M379.38,208.16c-19.99,4.88-39.83-6.04-44.31-24.4l-1.94-7.96l-0.83-3.97h-34.87l-0.83,3.97 l-1.94,7.96c-4.48,18.35-24.31,29.28-44.31,24.4l35.82-144.04c2.19-8.98,7.15-15.24,14.91-19.68c4.15-2.37,8.78-3.7,13.78-3.7 c5,0,9.63,1.34,13.78,3.7c7.76,4.44,12.72,10.71,14.92,19.68L379.38,208.16z M326.08,141.92l-11.21-53.87l-11.21,53.87H326.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EDF9"
    },
    d: "M500,156.91v1.4c0,28.13-22.88,51.01-51.01,51.01h-57.68c0-21.71,16.15-38.37,36.08-38.37h21.6 c6.85,0,12.64-5.79,12.64-12.64v-1.4c0-6.85-5.79-12.64-12.64-12.64h-12.14c-16.7,0-31.55-8.06-40.86-20.5l0,0 c-6.37-8.51-10.15-19.07-10.15-30.5v-1.4c0-28.13,22.88-51,51.01-51h53.34c0,21.7-16.15,38.36-36.08,38.36h-17.26 c-6.85,0-12.64,5.79-12.64,12.64v1.4c0,6.85,5.79,12.64,12.64,12.64h12.14c16.7,0,31.55,8.06,40.86,20.5 C496.22,134.92,500,145.48,500,156.91z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.957,
    y1: 189.5491,
    x2: 191.5693,
    y2: 189.5491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_1_)"
    },
    d: "M191.57,209.31h-14.61c0-4.91,0-9.82,0-14.73c0-8.27,0-16.53,0-24.8 c4.87,0,9.74,0,14.61,0V209.31z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061456725925635973550000011144804818162581436_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.0751,
    y1: 158.6426,
    x2: 311.6199,
    y2: 158.6426,
    gradientTransform: "matrix(0.9824 0.1866 -0.1553 0.8174 29.5015 -30.0413)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000061456725925635973550000011144804818162581436_)"
    },
    d: "M312.49,171.84l-14.87,0 c0.71-3.72,1.41-7.43,2.12-11.15c1.19-6.26,2.73-12.51,3.92-18.77h11.21L312.49,171.84z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003799852373289075670000005040903961765576866_",
    gradientUnits: "userSpaceOnUse",
    x1: 442.981,
    y1: 125.786,
    x2: 455.7539,
    y2: 126.7024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000003799852373289075670000005040903961765576866_)"
    },
    d: "M457.05,147.26 c-1.92-1.58-4.77-3.04-8.06-2.99l-6.07,0c0,0,0-9.52,0-14.31c0-8.07,0-15.99,0-24.06l6.07,0c4.04,0.04,6.36,0.3,10.1,1.01 L457.05,147.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.51,
    y: 96.74,
    style: {
      fill: "#BCD6F0"
    },
    width: 21.79,
    height: 32.73
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4EDF9"
    },
    d: "M10.3,79.28L0.19,83.77v7.22L10.3,86.5l30.2,4.49v-7.22L10.3,79.28z M118.74,74.71 c-2.84-7.39-6.89-13.62-12.16-18.68c-5.26-5.06-11.64-8.92-19.12-11.57c-7.48-2.65-15.79-3.98-24.94-3.98H38.33 c-18.24,0-38.15,17.15-38.15,38.31v0.72l10.11-4.5l30.2,4.5h18.91c7.34,0,13.06,1.9,17.15,5.69c4.08,3.8,6.13,9.33,6.13,16.6 v0.48c0,6.79-2.05,12.16-6.13,16.11c-4.09,3.96-9.73,5.94-16.94,5.94H40.5v-29.1l-30.2-4.49L0.19,95.24v113.92h0.02 c0.07,0,0.32,0,0.32,0c1.28-0.01,2.54-0.09,3.79-0.24c0.17-0.02,0.36-0.04,0.55-0.07c0.78-0.1,1.55-0.23,2.31-0.38 c0.1-0.01,0.2-0.03,0.3-0.06c0.16-0.03,0.31-0.07,0.45-0.11c0.46-0.1,0.91-0.21,1.36-0.33c0.14-0.03,0.29-0.08,0.43-0.12 c0.05-0.01,0.1-0.02,0.16-0.04c0.15-0.04,0.29-0.08,0.44-0.12c6.75-2.02,12.82-6.02,17.7-11.43c0.24-0.26,0.48-0.53,0.71-0.8 c0.14-0.17,0.28-0.34,0.42-0.51c0.04-0.05,0.08-0.1,0.12-0.14c0.42-0.51,0.83-1.03,1.23-1.56c0.09-0.12,0.18-0.24,0.27-0.36 c2.91-3.93,5.29-8.42,6.95-13.32c0.06-0.17,0.11-0.33,0.17-0.5c0.07-0.22,0.14-0.44,0.21-0.66c1.57-4.99,2.42-10.37,2.42-15.99 v-1.45h19.95c9,0,17.35-1.28,25.04-3.85c7.68-2.57,14.3-6.42,19.84-11.56c5.54-5.14,9.87-11.49,12.99-19.04 c3.12-7.55,4.68-16.3,4.68-26.26v-0.48C123.01,90.45,121.58,82.1,118.74,74.71z M14.51,96.74l21.79,3.24v11.85l-21.79-3.24V96.74 z M14.51,114.37l21.79,3.24v11.86l-21.79-3.24V114.37z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BCD6F0"
    },
    d: "M10.3,90.75L0.19,95.24v113.92c0,0,4.2,0.22,10.11-1.48V90.75z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 10.3,
    y1: 79.41,
    x2: 10.3,
    y2: 86.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 10.3,
    y1: 79.41,
    x2: 10.3,
    y2: 86.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BCD6F0"
    },
    points: "10.3,86.5 0.19,90.99 0.19,83.77 10.3,79.28  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M28.42,72.88"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M10.3,72.88"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056424530470583229070000015763319809307574962_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.5042,
    y1: 149.5834,
    x2: 40.5042,
    y2: 149.5834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000056424530470583229070000015763319809307574962_)"
    },
    d: "M40.5,149.58"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000928333177778679490000010264905429646919554_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.5044,
    y1: 142.6567,
    x2: 57.0004,
    y2: 142.6567
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000000928333177778679490000010264905429646919554_)"
    },
    d: "M57,160.97H40.5 c0-4.55,0-9.1,0-13.65c0-7.66,0-15.32,0-22.98c5.5,0,11,0,16.5,0V160.97z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027572515963501590120000016558473619778454168_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.7638,
    y1: 189.4014,
    x2: 24.5785,
    y2: 176.2453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fill: "url(#SVGID_00000027572515963501590120000016558473619778454168_)"
    },
    d: "M0.2,185.73 C0.2,185.73,0.15,185.73,0.2,185.73c18.96,0.24,40.31-19.1,40.31-50.27l0,0l0,25.51l0,0c0.52,29.86-20.69,48.58-40.32,48.19 c-0.04,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044154276000000857380000008992574308827672489_",
    gradientUnits: "userSpaceOnUse",
    x1: 474.6053,
    y1: 176.9723,
    x2: 486.5291,
    y2: 179.818,
    gradientTransform: "matrix(-0.8951 -0.4458 0.4458 -0.8951 376.4226 563.5543)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#76AADB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "url(#SVGID_00000044154276000000857380000008992574308827672489_)"
    },
    d: "M40.5,160.97 c0.63,29.27-20.16,48.48-40.3,48.19c-0.04,0,0,0,0,0C7.87,199.98,33.17,169.7,40.5,160.97L40.5,160.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E76A24"
    },
    d: "M10.28,86.5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E76A24"
    },
    d: "M10.28,79.41"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M28.41,72.89"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76AADB"
    },
    d: "M10.28,72.89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000108307648224068928540000008138025180615082381_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.4846,
    y1: 149.5879,
    x2: 40.4846,
    y2: 149.5879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#5E89B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#76AADB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000108307648224068928540000008138025180615082381_)"
    },
    d: "M40.48,149.59"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlasLogo3HorizontalWhiteBig);
export default __webpack_public_path__ + "static/media/Plas-logo-3-horizontal-white-big.7ca02235a20fa0caa72876fe3bc23009.svg";
export { ForwardRef as ReactComponent };